/**
 * Admin Dashboard Route
 * Requires admin role to access
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import { AdminDashboard } from '../../pages/Admin/AdminDashboard';

export const Route = createFileRoute('/_authenticated/admin')({
  beforeLoad: ({ context }) => {
    // Check if user is admin
    const user = (context as any)?.user;
    if (user && user.role !== 'admin') {
      throw redirect({
        to: '/home',
      });
    }
  },
  component: AdminDashboard,
});
